<template>
  <Layout :pagetitle="$t('Moviment report')">
    <b-form-row class="justify-content-between align-items-center py-2 mb-2">
      <span class="col-6 col-md-6 card-title h2">{{ report.name }}</span>
      <div class="col-6 col-md-3">
        <input
          class="form-control"
          type="text"
          v-if="$store.state.isAuthenticated"
          :placeholder="$t('Digite o Token e pressione enter')"
          v-model="report.token"
          @keyup.enter="getReport(currentMonth)"
        />
      </div>
      <div class="col-6 col-md-3">
        <input class="form-control" type="month" v-model="currentMonth" @change="getReport(currentMonth)" />
      </div>
    </b-form-row>
    <div class="row">
      <div class="col-12">
        <div class="card border border-primary">
          <div class="card-header bg-transparent border-primary py-1">
            <h5 class="my-0 text-primary"><i class="mdi mdi-chart-line me-3"></i>{{ $t('Sumário') }}</h5>
          </div>
          <div class="card-body d-flex flex-wrap">
            <div class="col-4 col-md-3 col-lg-2" v-for="(sumary, index) in modelReport" :key="index">
              <span class="text-muted small d-block">
                {{ sumary.label }}
                <span v-if="message != '' && sumary.key == 'qty_user'" :title="message">
                  <eva-icon class="icon nav-icon cursor-pointer mb-1" name="info-outline" />
                </span>
              </span>
              <span
                class="h5 cursor-pointer"
                v-if="sumary.key == 'qty_user' || sumary.key == 'reward_mark_count' || sumary.key == 'registers'"
              >
                <span>{{ sumary.sum }}</span>
              </span>
              <span class="h5" v-else>{{ formatCurrency(sumary.sum, { prefix: '' }) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        :class="`col-12 col-lg-6 classe-de-teste ${product.productType}-summary`"
        v-for="(product, index) in report.products"
        :key="index"
      >
        <div class="card border border-primary">
          <div class="card-header bg-transparent border-primary py-1">
            <b-row>
              <b-col>
                <div>
                  <h5 class="my-0 text-primary">
                    <i
                      :class="`fas ${
                        product.productType == 'lotto'
                          ? 'fa-ticket-alt'
                          : product.productType == 'games'
                          ? 'fa-gamepad'
                          : 'fa-running'
                      } me-3`"
                    ></i>
                    {{ product.productType }}
                  </h5>
                </div>
              </b-col>
              <b-col md="2" class="d-flex justify-content-end" v-if="product.productType == 'lotto'">
                <i
                  class="fas fa-list mt-1 text-primary cursor-pointer"
                  :title="$t('Details')"
                  @click="lottoDetailsModal = true"
                />
              </b-col>
            </b-row>
          </div>
          <div class="card-body d-flex flex-wrap">
            <div class="col-4 col-md-3">
              <span class="text-muted small d-block">{{ $t('Venda') }}</span>
              <span class="h5">{{ formatCurrency(product.turnover, { prefix: '' }) }}</span>
            </div>
            <div class="col-4 col-md-3">
              <span class="text-muted small d-block">{{ $t('Prêmio') }}</span>
              <span class="h5">{{ formatCurrency(product.payout, { prefix: '' }) }}</span>
            </div>
            <div class="col-4 col-md-3">
              <span class="text-muted small d-block">{{ $t('Bônus') }}</span>
              <span class="h5">{{ formatCurrency(product.bonus, { prefix: '' }) }}</span>
            </div>
            <div class="col-4 col-md-3">
              <span class="text-muted small d-block">{{ 'GGR' }}</span>
              <span class="h5">{{ formatCurrency(product.ggr, { prefix: '' }) }}</span>
            </div>
            <div class="col-4 col-md-3">
              <span class="text-muted small d-block">{{ $t('Taxa Admin.') }}</span>
              <span class="h5">{{ formatCurrency(product.tax, { prefix: '' }) }}</span>
            </div>
            <div class="col-4 col-md-3">
              <span class="text-muted small d-block">{{ $t('Líquido') }}</span>
              <span class="h5">{{ formatCurrency(product.net, { prefix: '' }) }}</span>
            </div>
            <div class="col-4 col-md-3">
              <span class="text-muted small d-block">{{ $t('Comissão') }}</span>
              <span class="h5">{{ formatCurrency(product.reward, { prefix: '' }) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal :title="$t('Details')" v-model="lottoDetailsModal" size="lg" hide-footer>
      <div>
        <b-row v-if="lottoDetails.length == 0">
          <b-col class="text-center"> {{ $t('Total de registros') }}: {{ lottoDetails.length }} </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <small>
              <i class="fas fa-info-circle text-primary"></i>
              {{ $t('Detalhe de comissões configuradas que possuem movimento no período') }}
            </small>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <div class="row">
              <div
                :class="`col-12 col-lg-12 summary-${product.slug}`"
                v-for="(product, index) in lottoDetails"
                :key="index"
              >
                <div class="card border border-primary">
                  <div class="card-header bg-transparent border-primary py-1">
                    <b-row>
                      <b-col>
                        <div>
                          <h5 class="my-0 text-primary">
                            <i
                              :class="`fas ${
                                product.slug == 'lotto'
                                  ? 'fa-ticket-alt'
                                  : product.productType == 'games'
                                  ? 'fa-gamepad'
                                  : 'fa-running'
                              } me-3`"
                            ></i>
                            {{ product.productType }}
                          </h5>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="card-body d-flex flex-wrap">
                    <div class="col-4 col-md-3">
                      <span class="text-muted small d-block">{{ $t('Venda') }}</span>
                      <span class="h5">{{ formatCurrency(product.turnover, { prefix: '' }) }}</span>
                    </div>
                    <div class="col-4 col-md-3">
                      <span class="text-muted small d-block">{{ $t('Prêmio') }}</span>
                      <span class="h5">{{ formatCurrency(product.payout, { prefix: '' }) }}</span>
                    </div>
                    <div class="col-4 col-md-3">
                      <span class="text-muted small d-block">{{ $t('Bônus') }}</span>
                      <span class="h5">{{ formatCurrency(product.bonus, { prefix: '' }) }}</span>
                    </div>
                    <div class="col-4 col-md-3">
                      <span class="text-muted small d-block">{{ $t('GGR') }}</span>
                      <span class="h5">{{ formatCurrency(product.ggr, { prefix: '' }) }}</span>
                    </div>
                    <div class="col-4 col-md-3">
                      <span class="text-muted small d-block">{{ $t('Taxa Admin.') }}</span>
                      <span class="h5">{{ formatCurrency(product.tax, { prefix: '' }) }}</span>
                    </div>
                    <div class="col-4 col-md-3">
                      <span class="text-muted small d-block">{{ $t('Líquido') }}</span>
                      <span class="h5">{{ formatCurrency(product.net, { prefix: '' }) }}</span>
                    </div>
                    <div class="col-4 col-md-3">
                      <span class="text-muted small d-block">{{ $t('Comissão') }}</span>
                      <span class="h5">{{ formatCurrency(product.reward, { prefix: '' }) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import moment from 'moment';
import Layout from '../../../layouts/main';
import store from '../../../../state/store';
import api from '../../../../services/data.services';
import { useToast } from 'vue-toastification';

export default {
  components: { Layout },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      message: '',
      currentMonth: moment().format('YYYY-MM'),
      report: {
        name: null,
        token: null,
        products: [],
        lottoSummary: []
      },
      lottoDetailsModal: false,
      lottoDetails: []
    };
  },
  computed: {
    hideCpa() {
      this.$store.state.companySettings;
      return this.shouldHideCpa();
    },
    modelReport() {
      this.$store.state.companySettings;
      let report = [
        {
          key: 'qty_user',
          label: `${this.$t('Users')} (${this.$t('Active')})`,
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'turnover',
          label: this.$t('Venda'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'payout',
          label: this.$t('Prêmio'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'bonus',
          label: this.$t('Bônus'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'ggr',
          label: this.$t('GGR'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'tax',
          label: this.$t('Taxa Admin.'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'net',
          label: this.$t('Líquido'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'reward',
          label: this.$t('Comissão'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'reward_total',
          label: this.$t('Total'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'registers',
          label: `${this.$t('Users')} (${this.$t('Register')})`,
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        },
        {
          key: 'ftd_count',
          label: this.$t('FTD'),
          sortable: true,
          thClass: 'text-center',
          class: 'text-center',
          sum: 0
        }
      ];

      if (!this.hideCpa) {
        report.push(
          {
            key: 'reward_mark_count',
            label: this.$t('Qtd CPA'),
            sortable: true,
            thClass: 'text-center',
            class: 'text-center',
            sum: 0
          },
          {
            key: 'reward_mark',
            label: this.$t('CPA'),
            sortable: true,
            thClass: 'text-center',
            class: 'text-center',
            sum: 0
          }
        );
      }

      return report;
    }
  },
  mounted() {
    if (Object.keys(store.state.reportAffiliateDetail).length > 0) {
      this.report = JSON.parse(JSON.stringify(store.state.reportAffiliateDetail));
      this.updateSumary(this.report);
    } else {
      //this.getReport(this.currentMonth);
    }
    this.setMessage();
  },
  methods: {
    getReport(fullMonth) {
      const [year, month] = fullMonth.split('-');
      this.lottoDetails = [];
      api
        .search('report', {
          token: this.report.token ? this.report.token : localStorage.getItem('token'),
          month: month,
          year: year
        })
        .then((res) => {
          this.report = this.$utils.getObjectRaw(res);
          this.updateSumary(this.report);
          this.currentMonth = fullMonth;
          this.loadLottoSummary();
        })
        .catch(() => {
          this.toast.warning(`${this.$t('Verifique se  o token do afiliado é válido')}`);
        });
      this.setMessage();
    },
    loadLottoSummary() {
      this.report.lottoSummary.forEach((item) => {
        this.lottoDetails.push({
          ...item,
          slug: 'lotto',
          productType: `${item.gameName} - ${item.gameId}`,
          tax: item.admin_fee,
          net: item.ggr - item.admin_fee
        });
      });
    },
    updateSumary(data) {
      this.clearSumary();

      data.products.forEach((item) => {
        Object.keys(item).forEach((el) => {
          let sumEl = this.modelReport.find((model) => {
            return model.key == el;
          });
          if (sumEl) sumEl.sum += item[el];
        });
      });

      if (!this.hideCpa) {
        let sumEl1 = this.modelReport.find((model) => {
          return model.key == 'reward_mark_count';
        });
        if (sumEl1) sumEl1.sum += Number(data.rewardMark.count);

        let sumEl2 = this.modelReport.find((model) => {
          return model.key == 'reward_mark';
        });
        if (sumEl2) sumEl2.sum += data.rewardMark.total;
      }

      let sumEl3 = this.modelReport.find((model) => {
        return model.key == 'reward_total';
      });
      if (sumEl3) sumEl3.sum += data.summary.total;

      let sumRegisters = this.modelReport.find((model) => {
        return model.key == 'registers';
      });
      if (sumRegisters) sumRegisters.sum = data?.summary?.registeredUsersCount || 0;

      let sumFtd = this.modelReport.find((model) => {
        return model.key == 'ftd_count';
      });
      if (sumFtd) sumFtd.sum = data?.summary?.ftd_count || 0;

      //this.modelReport[0].reward_mark = data.rewardMark.total;

      this.modelReport[0].sum = data.summary.activeUsersCount || 0;
    },
    clearSumary() {
      this.modelReport.forEach((el) => {
        el.sum = 0;
      });
    },
    formatCurrency(value, options = {}) {
      let opt = { prefix: 'R$ ', precision: 2, ...options };
      let output = value;

      let val = ((output || 0) / 1).toFixed(opt.precision).replace('.', ',');
      const numberFormated = `${opt.prefix}${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;

      return numberFormated;
    },
    startDate() {
      return moment(this.currentMonth).format('YYYY-MM-DD');
    },
    endDate() {
      return moment(this.currentMonth).add('months', 1).subtract('days', 1).format('YYYY-MM-DD');
    },
    firstDayOfMonth() {
      if (moment().format('YYYY-MM-DD') == moment(this.currentMonth).format('YYYY-MM-DD')) return true;
      return false;
    },
    currentMonthOnFilter() {
      if (moment().format('YYYY-MM') == moment(this.currentMonth).format('YYYY-MM')) return true;
      return false;
    },
    setMessage() {
      this.message = '';

      if (this.firstDayOfMonth()) {
        this.message = this.$t('Informação não disponível');
      } else if (this.currentMonthOnFilter()) {
        this.message = this.$t(
          'A quantidade de usuários exibida corresponde ao período compreendido entre o primeiro dia do mês atual e o dia anterior à data atual.'
        );
      }
    }
  }
};
</script>
